if (!customElements.get('alma-review-carousel')) {
  customElements.define('alma-review-carousel', class extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.alma-reviews__track');
      this.cards = Array.from(this.querySelectorAll('.er-review-card'));
      this.previous = this.querySelector('[data-review-previous]');
      this.next = this.querySelector('[data-review-next]');
      this.position = this.querySelector('[data-review-position]');
      if (!this.track || !this.cards.length || !this.previous || !this.next) return;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.previous.addEventListener('click', () => this.move(-1), options);
      this.next.addEventListener('click', () => this.move(1), options);
      this.track.addEventListener('keydown', (event) => {
        if (event.target !== this.track) return;
        if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
          event.preventDefault();
          this.move(event.key === 'ArrowLeft' ? -1 : 1);
        } else if (event.key === 'Home' || event.key === 'End') {
          event.preventDefault();
          this.scrollTo(event.key === 'Home' ? 0 : this.track.scrollWidth);
        }
      }, options);
      this.track.addEventListener('scroll', () => {
        cancelAnimationFrame(this.frame);
        this.frame = requestAnimationFrame(() => this.update());
      }, { ...options, passive: true });
      this.resizeObserver = new ResizeObserver(() => this.update());
      this.resizeObserver.observe(this.track);
      this.querySelector('.alma-reviews__navigation').hidden = false;
      this.update();
    }

    disconnectedCallback() {
      this.controller?.abort();
      this.resizeObserver?.disconnect();
      cancelAnimationFrame(this.frame);
    }

    cardStep() {
      return this.cards.length > 1
        ? this.cards[1].offsetLeft - this.cards[0].offsetLeft
        : this.cards[0].getBoundingClientRect().width;
    }

    scrollTo(left) {
      this.track.scrollTo({
        left,
        behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'
      });
    }

    move(direction) {
      const step = this.cardStep();
      const current = Math.round(this.track.scrollLeft / step);
      this.scrollTo((current + direction) * step);
    }

    update() {
      const step = this.cardStep();
      if (step <= 0) return;
      const maximum = Math.max(0, this.track.scrollWidth - this.track.clientWidth);
      const first = Math.round(this.track.scrollLeft / step) + 1;
      const visible = Math.max(1, Math.round(this.track.clientWidth / step));
      const last = Math.min(this.cards.length, first + visible - 1);
      this.previous.disabled = this.track.scrollLeft <= 2;
      this.next.disabled = this.track.scrollLeft >= maximum - 2;
      this.position.textContent = this.dataset.rangeTemplate
        .replace('__first__', first)
        .replace('__last__', last);
    }
  });
}
